import React, { Component } from 'react';
import { twMerge } from 'tailwind-merge';

import StockItemIcons from '../../../app/Search/components/card/StockItemIcons';
import MediaGridImage from './MediaGridImage';
import MediaGridVideo from './MediaGridVideo';

interface Props {
  collectionName: string;
  shouldDisplay: boolean;
  isFirst?: boolean;
  isVideo: boolean;
  title: string;
  url: string;
  previewUrl?: string;
  duration?: number;
  thumbnailUrl?: string;
}

class MediaGridItem extends Component<Props> {
  constructor() {
    super();
    this.listItemRef = React.createRef();
  }

  addClass(element, className) {
    if (!element.classList.contains(className)) {
      element.classList.add(className);
    }
  }

  removeClass(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    }
  }

  shouldComponentUpdate(nextProps) {
    const { shouldDisplay, isFirst } = nextProps;
    this.updateItemClasslist(shouldDisplay, isFirst);
    return false;
  }

  // mutate classlist instead of conditionally rendering the video/image components.
  // saves us from having to refetch sources + css updates are much less expensive
  // than DOM updates
  updateItemClasslist(shouldDisplay, isFirst) {
    const element = this.listItemRef.current;
    if (shouldDisplay) {
      this.addClass(element, 'shouldDisplay');
      if (isFirst) {
        this.addClass(element, 'isFirst');
      }
    } else {
      this.removeClass(element, 'shouldDisplay');
      this.removeClass(element, 'isFirst');
    }
  }

  render() {
    const {
      isVideo,
      title,
      url,
      previewUrl,
      thumbnailUrl,
      duration,
      collectionName,
      shouldDisplay,
    } = this.props;

    // don't want to show title on Footage/Motion Backgrounds etc.
    const isCollection = collectionName === 'Collections';
    return (
      <li
        ref={this.listItemRef}
        key={`mediaContentItem-${title}`}
        className={twMerge(
          'mediaGridContent-contentItem',
          shouldDisplay && 'shouldDisplay'
        )}
      >
        <StockItemIcons />
        {isVideo ? (
          <MediaGridVideo
            shouldShowDuration={!isCollection && !!duration}
            title={title}
            previewUrl={previewUrl}
            thumbnailUrl={thumbnailUrl}
            duration={duration}
            isCollection={isCollection}
            linkUrl={url}
          />
        ) : (
          <MediaGridImage
            thumbnailUrl={thumbnailUrl}
            isCollection={isCollection}
            linkUrl={url}
            title={title}
          />
        )}
      </li>
    );
  }
}

export default MediaGridItem;
